<template>
  <v-container v-show="this.data" fluid>
    <v-layout v-show="this.data" justify-center>
      <v-flex md5>
        <table class="data-tab">
          <tr>
            <th class="td1" style="text-align:left" colspan="2">
              Billing Reference
            </th>
            <td class="td1" style="text-align:left" colspan="2">
              {{ data.reference_no }}
            </td>
          </tr>
          <tr>
            <th class="td1" style="text-align:left" colspan="2">
              Cut-off Period
            </th>
            <td class="td1" style="text-align:left" colspan="2">
              {{ $dateFormat(data.start_date, "MMMM DD, YYYY") }} -
              {{ $dateFormat(data.end_date, "MMMM DD, YYYY") }}
            </td>
          </tr>
          <tr>
            <th class="td1" style="text-align:left" colspan="2">
              Gross Revenue
            </th>
            <td class="td1" style="text-align:right" colspan="2">
              {{ totalAmount ? $amountInPeso(totalAmount) : $amountInPeso(0) }}
            </td>
          </tr>
          <tr>
            <th class="td1" style="text-align:left" colspan="2">
              MDR ({{ data.mdr }}%)
            </th>
            <td class="td1" style="text-align:right" colspan="2">
              {{ totalMdr ? $amountInPeso(totalMdr) : $amountInPeso(0) }}
            </td>
          </tr>
          <tr>
            <th class="td1" style="text-align:left" colspan="2">
              {{
                data.merchant_status === 2
                  ? "Settled Amount:"
                  : "Amount to Settle:"
              }}
            </th>
            <td class="td1" style="text-align:right" colspan="2">
              {{ totalSettle ? $amountInPeso(totalSettle) : $amountInPeso(0) }}
            </td>
          </tr>
        </table>
      </v-flex>
      <v-flex md2></v-flex>
      <v-flex md5>
        <table v-if="showSettle" class="data-tab">
          <tr v-if="readOnly || data.merchant_status === 0">
            <td class="td1" style="text-align:center" colspan="4">
              <v-btn
                :disabled="!data.deposit_slip"
                @click="data.deposit_slip ? (openViewDialog = true) : ''"
                flat
                block
                >VIEW RECIEPT</v-btn
              >
            </td>
          </tr>
          <tr v-else>
            <td class="td1" style="text-align:center" colspan="1">RECIEPT</td>
            <td class="td1" style="text-align:center" colspan="3">
              <input
                class="ma-2"
                type="file"
                accept="image/*,.pdf"
                @change="uploadImage"
              />
            </td>
          </tr>
          <tr>
            <td class="td1" style="text-align:left" colspan="4">
              <v-form v-model="valid" ref="form" lazy-validation>
                <v-text-field
                  label="Bank Reference No."
                  v-model="data.bank_reference_no"
                  box
                  :rules="blank"
                  :readonly="readOnly"
                  required
                ></v-text-field>
              </v-form>
            </td>
          </tr>
        </table>
      </v-flex>
    </v-layout>

    <v-layout justify-center class="clsScroll">
      <v-btn
        v-show="this.showTrans == false"
        @click="getTransData()"
        :loading="showTranBtnLoading"
        depressed
        elevation="9"
        outlined
        plain
        x-large
        color="primary"
        >VIEW TRANSACTIONS</v-btn
      >
      <v-data-table
        v-show="this.showTrans && this.trans.length != 0"
        :headers="headers"
        :items="trans"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <!-- <td class="text-xs-center">{{ props.item.no }}</td> -->
          <td class="text-xs-center" data-v-136ff7b3>{{ props.index + 1 }}</td>
          <td class="text-xs-right text-no-wrap">
            {{ $dateFormat(props.item.date, "YYYY-MM-DD") }}
          </td>
          <td class="text-xs-center">
            {{ $dateFormat(props.item.date, "HH:mm:ss") }}
          </td>
          <!-- <td class="text-no-wrap text-xs-left">{{ props.item.location }}</td> -->
          <td class="text-no-wrap text-xs-center text-uppercase">{{ props.item.branch }}</td>
          <!-- <td class="text-no-wrap text-xs-left">
            {{ props.item.merchant_id }}
          </td> -->
          <td class="text-no-wrap text-xs-left">{{ props.item.control_no }}</td>
          <td class="text-no-wrap text-xs-center">{{ props.item.ticket_no }}</td>
          <td class="text-no-wrap text-xs-left">{{ props.item.card_no }}</td>
          <td class="text-no-wrap text-xs-left">
            {{ props.item.device_serial }}
          </td>
          <!-- <td class="text-no-wrap text-xs-center">
            {{ props.item.terminal ? props.item.terminal.toUpperCase() : null }}
          </td> -->
          <!-- <td class="text-no-wrap text-xs-left">{{ props.item.or_no }}</td> -->
          <td class="text-no-wrap text-xs-center">
            {{ $amountInPeso(props.item.amount) }}
          </td>
          <td class="text-no-wrap text-xs-center">
            {{ $amountInPeso(props.item.mdr) }}
          </td>
          <td>
            <v-radio-group
              :readonly="readOnly || data.merchant_status === 1"
              v-model="props.item.settle"
              row
              style="width: 187px; height: 10px;"
              class="mb-1"
            >
              <v-radio
                color="teal"
                label="Settle"
                :value="0"
                style="height: 10px;"
              ></v-radio>
              <v-radio
                class
                color="pink"
                label="Cancel"
                :value="1"
                style="height: 10px;"
              ></v-radio>
            </v-radio-group>
          </td>
          <td>
            <input
              :readonly="readOnly || data.merchant_status === 1"
              type="text"
              name="test"
              v-model="props.item.remarks"
            />
          </td>
        </template>
      </v-data-table>

      <v-dialog
        v-model="openViewDialog"
        max-width="700"
        @keydown.esc="openViewDialog = false"
      >
        <v-card v-show="data.deposit_slip" width="100%" height="500px">
          <v-img
            :src="data.deposit_slip ? data.deposit_slip : ''"
            alt="reciept"
            class="white--text align-center"
          ></v-img>
          <embed
            :src="data.deposit_slip ? data.deposit_slip + '#toolbar=0' : ''"
            width="100%"
            height="100%"
          />
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import CommonServices from "@/services/CommonServices";

export default {
  props: {
    data: Object,
    items: Array,
    headers: Array,
    showSettle: Boolean,
    readOnly: Boolean,
  },
  data() {
    return {
      transQueryParams: {
        id: null,
        mdr: null,
      },
      showTranBtnLoading: false,
      trans: [],
      showTrans: false,
      rowsPerPageItems: [100, 200, 300, 400, 500],
      pagination: {
        itemsPerPage: 30,
        itemsLength: 30,
      },
      items1: [
        {
          date: "May 8, 2019",
          time: "17:20:03",
          location: "PAS",
          branch: "TRIP1",
          merchant_id: "TRIPKO",
          device_id: "WP18371Q000000058",
          or_no: "TRIPKO-0000001",
          amount: 1200,
          mdr: 24,
          remarks: null,
        },
        {
          date: "May 8, 2019",
          time: "18:23:03",
          location: "PAS",
          branch: "TRIP1",
          merchant_id: "TRIPKO",
          device_id: "WP18371Q000000058",
          or_no: "TRIPKO-0000002",
          amount: 1200,
          mdr: 24,
          remarks: "test",
        },
      ],
      radioGroup: "test",
      previewImage: null,
      openViewDialog: false,
      reference_no: null,
      valid: true,
      blank: [(val) => (val || "").length > 0 || "This field is required"],
    };
  },
  created() {},
  computed: {
    downloadData() {
      let theData = [];
      this.trans.forEach((item) => {
        let theJSON = {
          date: this.$dateFormat(item.date, "YYYY-MM-DD"),
          time: this.$dateFormat(item.date, "HH:mm:ss"),
          // location: item.location,
          branch: item.branch,
          // merchant_id: item.merchant_id,
          control_no: item.control_no,
          ticket_no: item.ticket_no,
          card_no: item.card_no,
          device_serial: item.device_serial,
          // terminal: item.terminal,
          // or_no: item.or_no,
          amount: item.amount,
          mdr: item.mdr,
          action: item.settle ? "CANCEL" : "SETTLE",
          remarks: item.remarks,
        };
        theData.push(theJSON);
      });
      return theData;
    },
    computedData() {
      return {
        id: this.data.id,
        bank_reference_no: this.data.bank_reference_no,
        items: this.trans ? this.trans : [],
        amount_settled: this.totalSettle,
        deposit_slip: this.previewImage,
        total_amount: this.totalAmount,
      };
    },
    totalAmount() {
      if (this.trans.length > 0) {
        let sum = 0;
        this.trans.map(function(value, key) {
          if (value.settle === 0) {
            sum += parseFloat(value.amount);
          }
        });
        return parseFloat(this.$roundOffByHundreds(sum));
      } else {
        return parseFloat(this.$roundOffByHundreds(this.data.total_amount));
      }
    },
    totalMdr() {
      if (this.trans.length > 0) {
        let sum = 0;
        this.trans.map(function(value, key) {
          if (value.settle === 0) {
            sum += parseFloat(value.mdr);
          }
        });
        return parseFloat(this.$roundOffByHundreds(sum));
      } else {
        return parseFloat(this.$roundOffByHundreds(this.data.total_mdr));
      }
    },
    totalSettle() {
        let val = 0;
        val = this.totalAmount - this.totalMdr;
        return parseFloat(val);
    },
  },
  methods: {
    async getTransData() {
      this.transQueryParams.id = this.data.id;
      this.transQueryParams.mdr = this.data.mdr;
      this.showTranBtnLoading = true;
      let transactions = [];
      try {
        transactions = await CommonServices.getSettlementTrans(
          this.transQueryParams
        );
      } catch (error) {
        this.showTranBtnLoading = false;
          console.log(error);
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
      }
      if (transactions.data.trans.length == 0) {
        this.showTranBtnLoading = false;
        this.$infoBar({
          type: "error",
          text: "No transaction data!",
        });
      }
      this.trans = transactions.data.trans;
      setTimeout(() => {
        if (this.trans.length > 0) {
          this.showTranBtnLoading = false;
          this.showTrans = true;
        }
      }, 1000);
    },
    uploadImage(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (files[0] === undefined) {
        this.fileinput = "";
      }
      if (!files.length) return;

      const image = files[0];

      const reader = new FileReader();

      reader.readAsDataURL(image);

      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },
    validateForm() {
      return this.$refs.form.validate();
    },
    clear() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style scoped>
.data-tab {
  border: 2px solid;
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
  table-layout: fixed;
}
.data-tabletab {
  width: 100%;
}
.td1 {
  border: 2px solid;
  padding-right: 10px;
  padding-left: 10px;
}
.clsScroll {
  width: auto;
  overflow-x: auto;
  overflow-y: hidden;
}
input[type="text"] {
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}
select {
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}
.uploading-image {
  display: flex;
}
.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
